export const convertToFunctionButton = {
  title: 'Convert SMS template to a new function',
  subtitle:
    'Converting an SMS template to a re-usable function allows for advanced SMS control. Manage this new function in the functions page.',
  tooltip:
    'Send SMS templates in functions allowing advanced control over content and recipient.',
  triggerText: 'Turn into function',
};
